import React, { useEffect, useState } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// Load module after Highcharts is loaded
require('highcharts/modules/exporting')(Highcharts);

/* 
This Graph shows up on the synopsis page, under experiments started by week
*/
function ExpByWeeksGraph({ name, data }) {
  const [options, setOptions] = useState({});

  useEffect(() => {
    let options = {
      chart: { type: 'column' },
      legend: { enabled: false },
      title: { text: name, align: 'center' },
      yAxis: { title: { enabled: false } },
      xAxis: { categories: data.categories, title: { enabled: false } },
      series: data.series,
      credits: {
        enabled: false
      }
    };
    setOptions(options);
  }, [name, data]);

  return (
    <div className="graph">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}

export default ExpByWeeksGraph;